// Core requirements for Bootstrap 5 Webpack Entry Modules
import ko from 'knockout';
import mapping from 'ko.mapping';
ko.mapping = mapping;

import 'bootstrap5';

import 'hqwebapp/js/bootstrap5/common';
import 'hqwebapp/js/bootstrap5/base_main';
import 'open-chat-studio-widget';
